module.exports = __webpack_public_path__ + "static/img/contant_4.5988d80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_2/contant_4.jpg
// module id = tzVb
// module chunks = 0